import { Component, Mixins } from 'vue-property-decorator';
import { yandexMap as YandexMap, ymapMarker as YmapMarker } from 'vue-yandex-maps';
import PageOuter from '@/components/page/organization/photos';
import CardMixin from '../common';
import { getCoords, getMarker } from './tools';

@Component({
  components: {
    PageOuter,
    YandexMap,
    YmapMarker,
  }
})
export default class PageOrganizationCardMap extends Mixins(CardMixin) {
  // Data
  isMounted: boolean = false;

  // Computed
  get coords() {
    return getCoords(this.organization);
  }

  get hasCoords() {
    return this.markers.length > 0;
  }

  get markers() {
    const { organization } = this;
    const { filials = [] } = organization;
    return [
      getMarker(organization),
      ...filials.map(filial => getMarker(filial)),
    ]
    .filter(({ coords }) => {
      const [la, lo] = coords;
      return la !== null && lo !== null;
    });
  }

  // Hooks
  mounted() {
    this.isMounted = true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/organizations/card/map/script.ts